export const SERVICE_ACHIEVEMENTS = 'achievements';
export const SERVICE_SURVEYS = 'surveys';
export const SERVICE_WS = 'ws';
export const SERVICE_EVENTS = 'events';
export const SERVICE_NOTIFICATIONS = 'notifications';